import React, { useState, useEffect } from 'react';
import KPIHeader from '../../Header/KPIHeader';
import KPISubHeader from '../../Header/SubHeader/KPISubHeader';
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { canAccess } from "../../utils/pidConfigComponent";

import StateWiseStatistics     from '../../KPI/Project Level/StateWiseStatistics';
import StatusSummaryChart      from '../../KPI/Project Level/StatusSummaryChart';
import WaterfallChartComponent from '../../KPI/Project Level/WaterfallChartComponent';
import FunnelChartComponent    from '../../KPI/Project Level/FunnelChart';
import FunnelViewChart         from '../../KPI/Project Level/FunnelViewChart';
import AttributesDashboard     from '../../KPI/Project Level/AttributesDashboard';
import ProjectLevelDefitions   from '../../Defintions/ProjectLevelDefitions';
import EnterpriseMsmeTable     from '../../KPI/enterprise/EnterpriseMsmeTable';

import { getSession }        from "../../utils/session";
import { setProjectDetails } from "../../userSlice";
import { VIEW_IDS }          from "../../constants/ViewIds";   // ← capital V
import CaseReport from '../../KPI/Project Level/CaseReport';
import DFLProjectSummary from '../../KPI/Project Level/DflCampSummary';

const Projectlevel = () => {
  const dispatch = useDispatch();

  const reduxProjectName = useSelector((state) => state.user.projectName);
  const reduxPid         = useSelector((state) => state.user.projectId);
  const reduxEmail       = useSelector((state) => state.user.email);
  const reduxViewIds     = useSelector((state) => state.user.viewIds);
  const isSuperuser      = useSelector(s => s.user.isSuperuser);

  const [projectName, setProjectName] = useState(reduxProjectName);
  const [pid,         setPid]         = useState(reduxPid);
  const [email,       setEmail]       = useState(reduxEmail);
  const [viewIds,     setViewIds]     = useState(reduxViewIds || []);
  const [loading,     setLoading]     = useState(true);

  // SESSION RESTORE
  useEffect(() => {
    const session = getSession();
    if (session?.email) {
      setProjectName(session.projectName);
      setPid(session.projectId);
      setEmail(session.email);
      setViewIds(session.viewIds || []);

      dispatch(setProjectDetails({
        email:            session.email,
        projectName:      session.projectName,
        projectId:        session.projectId,
        organizationName: session.organizationName,
        roleId:           session.roleId,
        viewIds:          session.viewIds || [],
      }));
    }
    setLoading(false);
  }, [dispatch]);

  // Keep in sync if Redux updates (e.g. user switches project without hard refresh)
  useEffect(() => {
    if (reduxViewIds?.length) setViewIds(reduxViewIds);
  }, [reduxViewIds]);

  if (loading) return null;
  if (!email)  return <Navigate to="/" replace />;

  const canView = (viewId) => viewIds.includes(viewId);

  const handleRedirect = () => window.open('https://dfl-insights.haqdarshak.com/', '_blank');

  return (
    <div className="bg-gray-50 min-h-screen">
      <KPIHeader />
      <KPISubHeader />

      <div className="mt-32">
        

        {/* CHARTS — each gated by view_id */}
        <div className="bg-gray-50 p-6">
          {canView(VIEW_IDS.SUMMARY_VIEW)    && <WaterfallChartComponent />}
          {canView(VIEW_IDS.WORK_DONE_VIEW)  && <FunnelChartComponent />}
          {canView(VIEW_IDS.FUNNEL_VIEW)     && <FunnelViewChart />}
        </div>

        {/* <button
          onClick={handleRedirect}
          className="group ml-[30vw] mb-4 px-6 py-3 rounded-full text-white bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700"
        >
          Click here to see DFL Camps Dashboard
        </button> */}

        {canView(VIEW_IDS.STATEWISE_STATISTICS)    && <StateWiseStatistics />}
        {canView(VIEW_IDS.WEEKWISE_ACHIEVEMENT)    && <StatusSummaryChart />}
        {canView(VIEW_IDS.CITIZEN_ATTRIBUTES)      && <AttributesDashboard />}
        {canView(VIEW_IDS.ENTREPRENEUR_MSME_SUMMARY) && canAccess(pid, "enterpriseMsme")&& <EnterpriseMsmeTable />}
         {canView(VIEW_IDS.DFL_CAMPS_SUMMARY) && <DFLProjectSummary/>}
        {(canView(VIEW_IDS.CASE_REPORT) || isSuperuser) && <CaseReport />}
       

      </div>
    </div>
  );
};

export default Projectlevel;